import { defaults } from "./default";

export const folderEndpoints = {
  addFolder: {
    v1: {
      ...defaults.methods.POST,
      ...defaults.versions.v1,
      uri: "/folder",
    },
  },
  getFolder: {
    v1: {
      ...defaults.methods.GET,
      ...defaults.versions.v1,
      uri: "/folder",
    },
  },
  updateSubFolder: {
    v1: {
      ...defaults.methods.PUT,
      ...defaults.versions.v1,
      uri: "/folder/sub/:id",
    },
  },
  getSubFolder: {
    v1: {
      ...defaults.methods.GET,
      ...defaults.versions.v1,
      uri: "/folder/sub/:id",
    },
  },
  addSubFolder: {
    v1: {
      ...defaults.methods.POST,
      ...defaults.versions.v1,
      uri: "/folder/sub/:id",
    },
  },
  deleteFolder: {
    v1: {
      ...defaults.methods.DELETE,
      ...defaults.versions.v1,
      uri: "/folder/:id",
    },
  },
  updateFolder: {
    v1: {
      ...defaults.methods.PUT,
      ...defaults.versions.v1,
      uri: "/folder/:id",
    },
  },
  addFolderImages: {
    v1: {
      ...defaults.methods.POST,
      ...defaults.versions.v1,
      uri: "/folder/image/:folderId",
    },
  },
  getFolderImages: {
    v1: {
      ...defaults.methods.GET,
      ...defaults.versions.v1,
      uri: "/folder/image/:folderId",
    },
  },
  deleteFolderImages: {
    v1: {
      ...defaults.methods.DELETE,
      ...defaults.versions.v1,
      uri: "/folder/folderImages",
    },
  },
};
